import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
// import Lightbox from 'react-image-lightbox';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withUser from '../../common/withUser';
import withOnline from '../../common/withOnline';
import withTableName from '../../common/withTableName';
import {
  getSelectedTeamName,
  onGoBack
} from '../../common/globals';
import Header from '../../components/Header';
import {
  caseXraysList,
  generateTimedURL,
  listSingleCase,
  removeXray,
  generateBulkTimedURL
} from '../../utils/utils';
import {
  updateTableCaseByPrimaryId,
  getTableCaseByCaseId
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import XrayDeleteConfirmation from '../../components/Models/XrayDeleteConfirmation';
import PdfIcon from '../../assets/images/file-pdf-box.png';
import FileIcon from '../../assets/images/file-document-outline.png';
import PdfNotDownloaded from '../../components/Models/PdfNotDownloaded';
import ImageWithLoader from '../../components/ImageWithLoader.js';

class Xray extends Component {
  constructor(props) {
    super(props);
    this.state = {
      xRayData: [],
      selectedXrayValue: [],
      xRayFileUrlData: [],
      photoIndex: 0,
      isOpen: false,
      showLightBox: false,
      screenWidth: ''
    };
    this.XrayDelete = null;
    this.PdfNotDownloaded = null;
  }

  componentDidMount() {
    try {
      this.XrayDelete = new window.bootstrap.Modal(window.$('#xrayDeleteModal'));
      this.PdfNotDownloaded = new window.bootstrap.Modal(window.$('#pdfNotDownloadedModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width });
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onUpload = () => {
    try {
      const { params: { id } } = this.props;
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/x-ray/upload`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getXrayLists = async () => {
    try {
      const {
        notify, setLoader, online, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      if (online) {
        setLoader(true);
        caseXraysList(caseDetailsRes.CaseScheduleID).then((responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            const sortXrayRes = data !== undefined ? data.sort((a, b) => a - b).reverse() : [];
            if (sortXrayRes.length > 0) {
              this._getFiles(sortXrayRes);
            }
            this.setState({ xRayData: sortXrayRes });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        setLoader(true);
        // Get the xRayData list if user is offline
        const data = caseDetailsRes.case_xrays;
        const sortXrayRes = data !== undefined ? data.sort((a, b) => a - b).reverse() : [];
        this.setState({ xRayData: sortXrayRes });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _openImage = async (XrayId) => {
    try {
      const {
        user, setLoader, notify, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      const generateTimedURLData = {
        team: await getSelectedTeamName(),
        entity_type: 'xrays',
        entity_id: XrayId,
        token: user.token,
        key: user.userKey,
        casescheduleid: caseDetailsRes.CaseScheduleID,
      };
      setLoader(true);
      generateTimedURL(generateTimedURLData).then((responseJson) => {
        setLoader(false);
        const { status, message, data } = responseJson;
        if (status) {
          if (message.length > 0) {
            // notify({ type: 'success', message });
          }
          window.open(data, '', 'width=900, height=900');
        } else {
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenXrayDeletePopup = (data) => {
    try {
      this.XrayDelete.show();
      this.setState({
        selectedXrayValue: data
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveXray = async (data) => {
    try {
      const {
        notify, setLoader, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      setLoader(true);
      removeXray(data.XRayID).then(async (responseJson) => {
        // setLoader(false);
        const { status, message } = responseJson;
        if (status) {
          if (message.length > 0) {
            // notify({ type: 'success', message });
          }
          const singleCaseRes = await listSingleCase(caseDetailsRes.CaseScheduleID);
          singleCaseRes.data[0].CaseDate = caseDetailsRes.CaseDate;
          singleCaseRes.data[0].CaseTime = caseDetailsRes.CaseTime;
          // await updateCase(singleCaseRes.data[0]);
          await updateTableCaseByPrimaryId(caseDetailsRes.id, singleCaseRes.data[0], tableName);
          await this._getXrayLists();
          setLoader(false);
        } else {
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getFiles = async (sortXrayRes) => {
    const XrayIds = sortXrayRes.length > 0 ? sortXrayRes.map((res) => res.XRayID) : [];
    if (XrayIds.length > 0) {
      try {
        const { user, setLoader, notify } = this.props;
        const generateTimedURLData = {
          team: await getSelectedTeamName(),
          entity_type: 'xrays',
          entity_id: JSON.stringify(XrayIds),
          token: user.token,
          key: user.userKey
        };
        setLoader(true);
        generateBulkTimedURL(generateTimedURLData).then((responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            const fileData = data.map((file) => {
              const profile = sortXrayRes.find((d) => (file.entity_id === d.XRayID));
              // const newItem = { fileType: profile.Filename };
              // boxData.push();
              const fileext = profile.Filename.split('.').pop();
              const docData = {
                src: file.url,
                entity_id: file.entity_id,
                title: profile.Name,
                fileType: fileext.toLowerCase() === 'pdf' ? 'pdf' : fileext.toLowerCase() === 'txt' ? 'txt' : 'image',
                order: fileext.toLowerCase() === 'pdf' ? 1 : 0
              };
              return docData;
            });
            // const sortFileData = _.orderBy(fileData, ['order'], ['desc']);
            const sortFilesData = _.chain(fileData)
              .orderBy(['order'], ['desc'])
              .groupBy('fileType')
              .map((value, key) => ({ type: key, files: value }))
              .value();
            this.setState({ xRayFileUrlData: sortFilesData });
            // window.open(data, '', 'width=900, height=900');
          } else {
            notify({ type: 'error', message });
          }
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    }
  }

  _openLightbox = (image) => {
    window.open(image.src, '_blank');
    // this.setState({ photoIndex: index, isOpen: true });
  };

  _closeLightbox = () => {
    this.setState({ photoIndex: 0, isOpen: false });
  };

  _gotoPrevious = (index, imgLength) => {
    const phIndex = (index + imgLength.length - 1) % imgLength.length;
    if (phIndex >= 0) {
      this.setState({ photoIndex: phIndex });
    }
  };

  _gotoNext = (index, imgLength) => {
    const phIndex = (index + 1) % imgLength.length;
    if (phIndex >= 0) {
      this.setState({ photoIndex: phIndex });
    }
  };

  _onCopyXray = (data) => {
    try {
      const { notify } = this.props;
      navigator.clipboard.writeText(data.src);
      notify({ type: 'success', message: 'URL Copied' });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickTextFile = () => {
    try {
      this.PdfNotDownloaded.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      this._getXrayLists();
      await this._getScreenWidth();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack } = this.props;
    const {
      xRayData, selectedXrayValue, xRayFileUrlData, screenWidth,
      // photoIndex, isOpen,
    } = this.state;
    return (
      <section className="xrays-section">
        <Header
          actionButton={{ title: 'Upload', onClick: this._onUpload }}
          title="X-rays"
          goBack={() => onGoBack(goBack)}
        />
        <div className="container">
          <div className="xrays-block">
            <div className="row">
              {
                (xRayData.length === 0)
                  ? (
                    <div className="col-12">
                      <img src="/assets/images/empty-xrays.png" alt="icon" />
                      <p> No x-rays have been<br />uploaded for this case.</p>
                    </div>
                  )
                  : (
                    <div className="col-12">
                      <p className="text-start">{xRayData !== undefined ? `X-rays: ${xRayData.length}` : 'X-rays: 0'}</p>
                      {
                        (xRayData.length > 0 && xRayFileUrlData.length > 0)
                          ? (
                            <ul className="list-unstyled xrays-list mb-0">
                              {
                                xRayFileUrlData.filter((f) => f.type === 'pdf').length > 0
                                  ? xRayFileUrlData.filter((f) => f.type === 'pdf')[0].files.map((pdf, k) => {
                                    const res = xRayData.filter(
                                      (d) => d.XRayID === pdf.entity_id
                                    );
                                    return (
                                      <>
                                        <li className="cursor-pointer d-flex text-uppercase" key={k}>
                                          <Link to={pdf.src} target="_blank" className="items text-center" key={k}>
                                            <span className="pdficon">
                                              <img src={PdfIcon} alt="pdficon" />
                                            </span>
                                          </Link>
                                          <button
                                            className={`btn btn-icon ${screenWidth > 800 ? 'desktop-xRay-copyBtn' : 'mobile-xRay-copyBtn'}`}
                                            onClick={
                                              () => this._onCopyXray(pdf)
                                            }
                                          ><i className="fas fa-copy" />
                                          </button>
                                          <button
                                            className="btn btn-icon"
                                            onClick={
                                              () => this._onOpenXrayDeletePopup(res[0])
                                            }
                                          ><i className="fas fa-trash" />
                                          </button>
                                        </li>
                                        <span className="xrays-title">{pdf.title}</span>
                                      </>
                                    );
                                  }) : ''
                              }
                              {
                                xRayFileUrlData.filter((f) => f.type === 'txt').length > 0
                                  ? xRayFileUrlData.filter((f) => f.type === 'txt')[0].files.map((txt, k) => {
                                    const res = xRayData.filter(
                                      (d) => d.XRayID === txt.entity_id
                                    );
                                    return (
                                      <>
                                        <li className="cursor-pointer d-flex text-uppercase" key={k}>
                                          <Link onClick={() => this._onClickTextFile(txt)} className="items text-center" key={k}>
                                            <span className="txticon">
                                              <img src={FileIcon} alt="txticon" />
                                            </span>
                                          </Link>
                                          <button
                                            className={`btn btn-icon ${screenWidth > 800 ? 'desktop-xRay-copyBtn' : 'mobile-xRay-copyBtn'}`}
                                            onClick={
                                              () => this._onCopyXray(txt)
                                            }
                                          ><i className="fas fa-copy" />
                                          </button>
                                          <button
                                            className="btn btn-icon"
                                            onClick={
                                              () => this._onOpenXrayDeletePopup(res[0])
                                            }
                                          ><i className="fas fa-trash" />
                                          </button>
                                        </li>
                                        <span className="xrays-title">{txt.title}</span>
                                      </>
                                    );
                                  }) : ''
                              }
                              {
                                xRayFileUrlData.filter((f) => f.type === 'image').length > 0
                                  ? (
                                    <>
                                      {
                                        xRayFileUrlData.filter((f) => f.type === 'image')[0].files.map((ig, i) => {
                                          // eslint-disable-next-line max-len
                                          const res = xRayData.filter((d) => d.XRayID === ig.entity_id);
                                          return (
                                            <>
                                              <li className="d-flex text-uppercase">
                                                <div
                                                  onClick={() => {
                                                    if (ig?.loaded) {
                                                      this._openLightbox(ig);
                                                    }
                                                  }} className="items cursor-pointer"
                                                  key={i}
                                                >
                                                  <ImageWithLoader
                                                    src={ig.src}
                                                    alt={ig.title}
                                                    isLazy
                                                    onImageLoad={() => {
                                                      ig.loaded = true;
                                                    }}
                                                  />
                                                </div>
                                                <button
                                                  className={`btn btn-icon ${screenWidth > 800 ? 'desktop-xRay-copyBtn' : 'mobile-xRay-copyBtn'}`}
                                                  onClick={
                                                    () => this._onCopyXray(ig)
                                                  }
                                                ><i className="fas fa-copy" />
                                                </button>
                                                <button
                                                  className="btn btn-icon"
                                                  onClick={
                                                    // eslint-disable-next-line max-len
                                                    () => this._onOpenXrayDeletePopup(res[0])
                                                  }
                                                ><i className="fas fa-trash" />
                                                </button>
                                              </li>
                                              <span className="xrays-title">{ig.title}</span>
                                            </>
                                          );
                                        })
                                      }
                                      {/* {isOpen && ( */}
                                      {/* <Lightbox */}
                                      {/*  mainSrc={xRayFileUrlData.filter((f) =>
                                               f.type === 'image')[0].files[photoIndex].src} */}
                                      {/*  nextSrc={xRayFileUrlData
                                              .filter((f) => f.type === 'image')[0]
                                              .files[photoIndex].src[(photoIndex + 1)
                                                % xRayFileUrlData.filter((f) => f.type === 'image')
                                                [0].files.length]} */}
                                      {/*  prevSrc={
                                              xRayFileUrlData
                                              .filter((f) => f.type === 'image')[0]
                                              .files[photoIndex].src[
                                              (photoIndex + xRayFileUrlData.filter(
                                              (f) => f.type === 'image')[0].files.length - 1)
                                              % xRayFileUrlData.filter(
                                              (f) => f.type === 'image')[0].files.length]} */}
                                      {/*  onCloseRequest={() => this._closeLightbox()} */}
                                      {/*  onMovePrevRequest={
                                              () => this._gotoPrevious(photoIndex,
                                              xRayFileUrlData.filter(
                                              (f) => f.type === 'image')[0].files)} */}
                                      {/*  onMoveNextRequest={
                                              () => this._gotoNext(photoIndex,
                                              xRayFileUrlData.filter(
                                              (f) => f.type === 'image')[0].files)} */}
                                      {/* /> */}
                                      {/* )} */}
                                    </>
                                  ) : ''
                              }
                            </ul>
                          ) : <div className="text-center">No X-ray found</div>
                      }
                    </div>
                  )
              }

              <div className="col-12">
                <p className="note">Note: All attachments will be deleted<br />
                  30 days after the case date.
                </p>
              </div>
            </div>
          </div>
        </div>
        <XrayDeleteConfirmation
          xRayData={selectedXrayValue}
          onDeleteXray={this._onRemoveXray}
        />
        <PdfNotDownloaded />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'XrayForm',
});

export default withTableName(
  withOnline(
    withUser(
      withGoBack(
        withForm(
          withNotify(
            withLoader(
              Xray
            )
          )
        )
      )
    )
  )
);
